import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { isTokenExpired } from "../features/auth/tokenUtils";
import { signOut } from "../features/auth/authSlice";
import { FirstPasswordPage } from "../pages/FirstPasswordPage";

export const ProtectedRoute = () => {
    const dispatch = useAppDispatch();
    const token = useAppSelector((state) => state.auth.accessToken);
    const mustChangePassword = useAppSelector((state) => Boolean(state.auth.profile?.mustChangePassword));
    const isExpired = token ? isTokenExpired(token) : false;
    useEffect(() => {
        if (token && isExpired) {
            dispatch(signOut());
        }
    }, [dispatch, isExpired, token]);
    if (!token || isExpired) {
        return <Navigate to="/auth" replace />;
    }
    // A temporary password is replaced before anything else (plan step 3):
    // the server refuses every other call until it is.
    if (mustChangePassword) {
        return <FirstPasswordPage />;
    }
    return <Outlet />;
};
